import { render, staticRenderFns } from "./reminder.vue?vue&type=template&id=24c18afc&scoped=true&"
import script from "./reminder.vue?vue&type=script&lang=js&"
export * from "./reminder.vue?vue&type=script&lang=js&"
import style0 from "./reminder.vue?vue&type=style&index=0&id=24c18afc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c18afc",
  null
  
)

export default component.exports